/*
 * Certificates Form Modal Messages
 *
 * This contains all the text for the Certificates Form Modal component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CertificatesFormModal';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Project Certificate',
  },
  message: {
    id: `${scope}.message`,
    defaultMessage: 'Please choose a certificate to be added',
  },
  certificates: {
    id: `${scope}.certificates`,
    defaultMessage: 'Certificates',
  },
});
